'use client';

import { Box, Flex, Text } from '@skin-seoul/design-system';
import NextImage from 'next/image';
import { SafeLink } from '@/components/ui/SafeLink';
import { format } from 'date-fns';
import { CLASSNAME } from '@skin-seoul/service';
type BlogCardProps = {
  title: string;
  image: string;
  date: string;
  readTime: string;
  link: string;
};
const BlogPostCard = ({
  title,
  image,
  date,
  readTime,
  link
}: BlogCardProps) => {
  return <SafeLink href={link} style={{
    textDecoration: 'none'
  }} width="100%" data-sentry-element="SafeLink" data-sentry-component="BlogPostCard" data-sentry-source-file="BlogPostCard.tsx">
      <Flex cursor="pointer" direction="column" width="100%" marginBottom={{
      base: 4,
      mobile: 8,
      desktop: 0
    }} data-sentry-element="Flex" data-sentry-source-file="BlogPostCard.tsx">
        <Box alignItems="center" borderRadius="8px" display="flex" height={{
        base: '160px',
        mobile: '170px',
        desktop: '300px'
      }} justifyContent="center" marginBottom={6} overflow="hidden" position="relative" width="100%" _hover={{
        '& > div': {
          transform: 'scale(1.05)'
        }
      }} data-sentry-element="Box" data-sentry-source-file="BlogPostCard.tsx">
          <Box height="100%" position="relative" width="100%" zIndex={2} transition="transform 0.3s ease" data-sentry-element="Box" data-sentry-source-file="BlogPostCard.tsx">
            <NextImage alt={title} fill src={image} sizes="(max-width: 480px) 100vw, (max-width: 768px) 50vw, (max-width: 1280px) 33vw, 25vw" priority style={{
            objectFit: 'cover'
          }} data-sentry-element="NextImage" data-sentry-source-file="BlogPostCard.tsx" />
          </Box>
        </Box>
        <Flex direction="column" gap={4} width="100%" data-sentry-element="Flex" data-sentry-source-file="BlogPostCard.tsx">
          <Text color="neutral.700" textStyle="paragraph.small" fontWeight="regular" lineClamp={2} data-sentry-element="Text" data-sentry-source-file="BlogPostCard.tsx">
            {title}
          </Text>
          <Flex alignItems="center" justifyContent="space-between" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Flex" data-sentry-source-file="BlogPostCard.tsx">
            <Text color="neutral.400" textStyle="paragraph.small" data-sentry-element="Text" data-sentry-source-file="BlogPostCard.tsx">
              {format(date, 'd LLL, yyyy')}
            </Text>
            <Text color="neutral.400" textStyle="paragraph.small" data-sentry-element="Text" data-sentry-source-file="BlogPostCard.tsx">
              {readTime}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </SafeLink>;
};
export default BlogPostCard;